(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lamsat-homepage"] && !Shopify.designMode) return;
  try {
    
  class LamsatReels extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.track = this.querySelector('[data-reels-track]');
      this.buttons = Array.from(this.querySelectorAll('[data-reels-arrow]'));
      this.videos = Array.from(this.querySelectorAll('video'));
      if (!this.track) return;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = this.dataset.autoplay === 'true' && !this.reducedMotion;
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.move(Number(button.dataset.reelsArrow)));
      });
      this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      });
      this.videos.forEach((video) => {
        video.addEventListener('play', () => this.pauseOthers(video));
      });
      this.visibilityHandler = () => {
        if (document.hidden) this.pauseOthers();
      };
      document.addEventListener('visibilitychange', this.visibilityHandler);
      if (this.autoplay && this.videos.length) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target.querySelector('video');
            if (!video) return;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.7) {
              this.pauseOthers(video);
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        }, { root: this.track, threshold: [0, 0.7, 1] });
        this.querySelectorAll('.lamsat-reel-card').forEach((card) => this.observer.observe(card));
      }
      requestAnimationFrame(() => this.updateButtons());
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.visibilityHandler) document.removeEventListener('visibilitychange', this.visibilityHandler);
    }

    move(direction) {
      const card = this.track.querySelector('.lamsat-reel-card');
      if (!card) return;
      const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: this.reducedMotion ? 'auto' : 'smooth' });
    }

    pauseOthers(activeVideo) {
      this.videos.forEach((video) => {
        if (video !== activeVideo) video.pause();
      });
    }

    updateButtons() {
      const atStart = this.track.scrollLeft <= 2;
      const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      const previous = this.querySelector('[data-reels-arrow="-1"]');
      const next = this.querySelector('[data-reels-arrow="1"]');
      if (previous) previous.disabled = atStart;
      if (next) next.disabled = atEnd;
    }
  }

  class LamsatReviewCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.track = this.querySelector('[data-review-track]');
      this.buttons = Array.from(this.querySelectorAll('[data-review-arrow]'));
      if (!this.track) return;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.move(Number(button.dataset.reviewArrow)));
      });
      this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      });
      requestAnimationFrame(() => this.updateButtons());
    }

    move(direction) {
      const card = this.track.querySelector('.lamsat-review-card');
      if (!card) return;
      const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: this.reducedMotion ? 'auto' : 'smooth' });
    }

    updateButtons() {
      const atStart = this.track.scrollLeft <= 2;
      const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      const previous = this.querySelector('[data-review-arrow="-1"]');
      const next = this.querySelector('[data-review-arrow="1"]');
      if (previous) previous.disabled = atStart;
      if (next) next.disabled = atEnd;
    }
  }

  if (!customElements.get('lamsat-reels')) customElements.define('lamsat-reels', LamsatReels);
  if (!customElements.get('lamsat-review-carousel')) customElements.define('lamsat-review-carousel', LamsatReviewCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lamsat-minimal-homepage"] && !Shopify.designMode) return;
  try {
    
  class LamsatMinimalSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.buttons = Array.from(this.querySelectorAll('[data-slider-direction]'));
      if (!this.track) return;
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const card = this.track.firstElementChild;
          if (!card) return;
          const styles = window.getComputedStyle(this.track);
          const gap = parseFloat(styles.columnGap || styles.gap || 0);
          this.track.scrollBy({ left: (card.getBoundingClientRect().width + gap) * Number(button.dataset.sliderDirection), behavior: 'smooth' });
        });
      });
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        this.buttons.forEach((button) => {
          const direction = Number(button.dataset.sliderDirection);
          button.disabled = direction < 0 ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= max;
        });
      };
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }
  }

  if (!customElements.get('lamsat-minimal-slider')) {
    customElements.define('lamsat-minimal-slider', LamsatMinimalSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lamsat-product-details"] && !Shopify.designMode) return;
  try {
    
  class LamsatProductReviews extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.track = this.querySelector('[data-review-track]');
      this.buttons = [...this.querySelectorAll('[data-review-arrow]')];
      if (!this.track) return;
      this.buttons.forEach((button) => button.addEventListener('click', () => this.move(Number(button.dataset.reviewArrow))));
      this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      });
      this.observer = new ResizeObserver(() => this.updateButtons());
      this.observer.observe(this.track);
      this.updateButtons();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    move(direction) {
      const card = this.track.querySelector('.lamsat-product-details__review');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    updateButtons() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.buttons.forEach((button) => {
        const direction = Number(button.dataset.reviewArrow);
        button.disabled = direction < 0 ? this.track.scrollLeft <= 3 : this.track.scrollLeft >= max - 3;
      });
    }
  }

  if (!customElements.get('lamsat-product-reviews')) {
    customElements.define('lamsat-product-reviews', LamsatProductReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
